import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { BrowserRouter as Router } from 'react-router-dom';
import AppRoutes from './ui/layout/AppRoutes';
import './App.css';
import { useAppDispatch, useAppSelector } from './application/store/useStore';
import { useEffect } from 'react';
import { stopPolling } from './application/utility/pooling/pooling';
import { getDocumentProcessStatusAsync } from './application/features/proposal/proposalThunk';
import { initiateChatAsync } from './application/features/chat/chatThunk';
import { ToastContainer } from 'react-toastify';
import { CompanyProvider } from './application/context/CompanyContext';
function App() {
    const { allProposals } = useAppSelector((state) => state.proposal);
    const queryParams = new URLSearchParams(window.location.search);
    const proposalId = queryParams.get('id'); // Get the 'id' parameter from URL
    const dispatch = useAppDispatch();
    useEffect(() => {
        const interval = setInterval(() => {
            if (allProposals?.some((x) => x.documentsProcess === 0)) {
                dispatch(getDocumentProcessStatusAsync({ background: true }))
                    .unwrap()
                    .then((response) => {
                    // Only re-initiate chat if the current proposal is in processing
                    const currentProposal = allProposals?.find((x) => x.id === proposalId);
                    if (proposalId && currentProposal?.documentsProcess === 0) {
                        dispatch(initiateChatAsync(proposalId));
                    }
                });
            }
            else {
                stopPolling();
            }
        }, 15000);
        return () => {
            clearInterval(interval);
            stopPolling();
        };
    }, [dispatch, allProposals, proposalId]);
    return (_jsx(CompanyProvider, { children: _jsxs("div", { className: 'App', children: [_jsx(ToastContainer, { position: 'top-right', newestOnTop: true, pauseOnHover: true, theme: 'colored' }), _jsx(Router, { children: _jsx(AppRoutes, {}) })] }) }));
}
export default App;
